import { useDisclosure } from "@chakra-ui/react";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { omit } from "lodash";
import Layout from "components/Layout";
import PageSection from "components/Layout/PageSection";
import HeadTitle from "components/Shared/HeadTitle";
import CreateButton from "components/Shared/CreateButton";
import DirectoryModal from "components/Retailers/Index/DirectoryModal";
import RetailersTableView from "components/Retailers/Index";

const OPEN_RETAILER_DIRECTORY_QUERY_PARAM = "openDirectory";

export default function RetailersIndex() {
  const router = useRouter();
  const {
    isOpen: isRetailerDirectoryModalOpen,
    onClose: handleCloseRetailerDirectoryModal,
    onOpen: handleOpenRetailerDirectoryModal,
  } = useDisclosure();

  useEffect(() => {
    if (
      !router.isReady ||
      router.query[OPEN_RETAILER_DIRECTORY_QUERY_PARAM] !== "1"
    ) {
      return;
    }

    handleOpenRetailerDirectoryModal();
    void router.replace(
      {
        pathname: router.pathname,
        query: omit(router.query, OPEN_RETAILER_DIRECTORY_QUERY_PARAM),
      },
      undefined,
      { shallow: true },
    );
  }, [handleOpenRetailerDirectoryModal, router]);

  return (
    <PageSection
      display="flex"
      flexFlow="column"
      height="100%"
      width="100%"
      isUnpadded
    >
      <HeadTitle title="Retailers" />

      <RetailersTableView
        headerRight={
          <CreateButton onClick={handleOpenRetailerDirectoryModal}>
            Add
          </CreateButton>
        }
      />

      <DirectoryModal
        isOpen={isRetailerDirectoryModalOpen}
        onClose={handleCloseRetailerDirectoryModal}
      />
    </PageSection>
  );
}

RetailersIndex.getLayout = (page: React.ReactElement) => (
  <Layout isFullHeight>{page}</Layout>
);
